import { getCarouselRatio } from "@ext/markdown/elements/gallery/logic/getGalleryItemRatio";
import { GALLERY_CELL } from "@ext/markdown/elements/gallery/logic/getMosaicStyles";

export const MAX_SLIDE_WIDTH = 80;

const cqw = (value: number) => `${+value.toFixed(4)}cqw`;

const getCarouselStyles = (scope: string, ratios: number[]) => {
	const aspectRatio = getCarouselRatio(ratios);
	const widths = ratios.map((ratio) => Math.min(MAX_SLIDE_WIDTH, (MAX_SLIDE_WIDTH * ratio) / aspectRatio));
	const edge = (width: number) => cqw((100 - width) / 2);

	return [
		`${scope} [data-gallery-items] { padding-inline: ${edge(widths[0])} ${edge(widths[widths.length - 1])}; }`,
		`${scope} ${GALLERY_CELL} * { height: ${cqw(MAX_SLIDE_WIDTH / aspectRatio)}; }`,
		...widths.map((width, index) => `${scope} ${GALLERY_CELL} :nth-child(${index + 1}) { width: ${cqw(width)}; }`),
	].join("\n");
};

export default getCarouselStyles;
